import { default as local } from './local.json';
import { default as address } from './address.json'

export default {
    ...local,
    ...address
}
